"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('module-slider', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M16 7H39.1429H48V23H39.1429H36L32 27L28 23H16V7Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M6 39L28 39",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M26 15H38",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M36 39H58",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M25 53C25 55.2091 23.2091 57 21 57C18.7909 57 17 55.2091 17 53C17 50.7909 18.7909 49 21 49C23.2091 49 25 50.7909 25 53Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M48 53C48 55.2091 46.2091 57 44 57C41.7909 57 40 55.2091 40 53C40 50.7909 41.7909 49 44 49C46.2091 49 48 50.7909 48 53Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M25 53C25 55.2091 23.2091 57 21 57C18.7909 57 17 55.2091 17 53M25 53C25 50.7909 23.2091 49 21 49C18.7909 49 17 50.7909 17 53M25 53H40M17 53H6M48 53C48 55.2091 46.2091 57 44 57C41.7909 57 40 55.2091 40 53M48 53C48 50.7909 46.2091 49 44 49C41.7909 49 40 50.7909 40 53M48 53H58",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("circle", {
    cx: "32",
    cy: "39",
    r: "4",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;